import { useState } from 'react';
import type { FooterAccordionLink } from '@amplience/content-types/typings/c-footer-accordion';
import { ArrowDownSmall } from '../../../icons';
import { transformTextToId } from '../../../utils/transformers';
import { AccordionLinkLabel } from '../footerAccordion/FooterAccordion';
import {
  MobileAccordionCommonLinkItem,
  MobileAccordionHeader,
  MobileAccordionHeaderText,
  MobileAccordionLinks,
} from './MobileFooterAccordion.styles';

export type MobileFooterAccordionProps = {
  title: string;
  commonLinks: FooterAccordionLink[];
};

export function MobileFooterAccordion({ title, commonLinks }: MobileFooterAccordionProps) {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const toggleAccordion = () => setIsAccordionOpen((prev) => !prev);

  return (
    <>
      <MobileAccordionHeader
        onClick={toggleAccordion}
        aria-labelledby={`${transformTextToId(title)}-accordion-header-button`}
        aria-expanded={isAccordionOpen}
        aria-controls={`footer-links-${transformTextToId(title)}`}
        type="button"
        $isAccordionOpen={isAccordionOpen}
      >
        <MobileAccordionHeaderText id={`${transformTextToId(title)}-accordion-header-button`}>
          {title}
        </MobileAccordionHeaderText>
        <ArrowDownSmall aria-hidden className="accordion-arrow-down" />
      </MobileAccordionHeader>

      <MobileAccordionLinks
        $isAccordionOpen={isAccordionOpen}
        id={`footer-links-${transformTextToId(title)}`}
        hidden={!isAccordionOpen}
        aria-hidden={!isAccordionOpen}
      >
        {commonLinks?.map(({ label, link }) => (
          <MobileAccordionCommonLinkItem key={String(label)}>
            <AccordionLinkLabel link={link} label={label} />
          </MobileAccordionCommonLinkItem>
        ))}
      </MobileAccordionLinks>
    </>
  );
}
